import { Timestamp } from '@griply/types';
import { format, isSameYear } from 'date-fns';

// "Jan" for a month in the current year, "Jan '25" when it falls in another
// year — so navigating a habit calendar across years stays unambiguous.
export const getCalendarMonthLabel = (
  date: Timestamp,
  today: Timestamp,
): string => format(date, isSameYear(date, today) ? 'LLL' : "LLL ''yy");
